module.exports = __webpack_public_path__ + "img/loading.4f6c7e6c.gif";